import React from 'react';
import { Instagram, Mail, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer
      className="border-t py-12"
      style={{ backgroundColor: '#FFFDEB', borderColor: 'rgba(74,21,75,0.12)' }}
    >
      <style>{`
        .footer-link { color: rgba(74,21,75,0.55); transition: color 0.2s; font-size: 0.875rem; }
        .footer-link:hover { color: #F4A1C8; }
        .footer-icon { color: rgba(74,21,75,0.4); transition: color 0.2s; }
        .footer-icon:hover { color: #F4A1C8; }
      `}</style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Logo and Description */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_e5e0b548-5d46-45b3-9c33-35f27ba77bc9/artifacts/ebf8d88f7278a8e3_Logo%202026%20G1%20alta.webp"
                alt="Talengers Logo"
                className="h-16 w-auto"
              />
            </div>
            <p className="text-sm" style={{ color: 'rgba(74,21,75,0.55)' }}>
              Agencia regional de management de artistas e influencers
            </p>
            <Link
              to="/panel"
              className="text-[10px] transition-colors"
              style={{ color: 'rgba(74,21,75,0.2)' }}
              data-testid="footer-link-panel"
            >
              TLG
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: '#4A154B' }}>Enlaces</h3>
            <ul className="space-y-2">
              <li><Link to="/#quienes-somos" className="footer-link">Quiénes Somos</Link></li>
              <li><Link to="/#talentos"       className="footer-link">Talentos</Link></li>
              <li><Link to="/#contacto"       className="footer-link">Contacto</Link></li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: '#4A154B' }}>Contacto</h3>
            <p className="text-sm mb-4" style={{ color: 'rgba(74,21,75,0.55)' }}>hello@talengersok.com</p>
            <div className="flex items-center space-x-4">
              <a href="https://www.instagram.com/talengers.ok/" target="_blank" rel="noopener noreferrer" className="footer-icon">
                <Instagram size={22} />
              </a>
              <a href="mailto:hello@talengersok.com" className="footer-icon">
                <Mail size={22} />
              </a>
              <a href="https://www.linkedin.com/company/talengersok/" target="_blank" rel="noopener noreferrer" className="footer-icon">
                <Linkedin size={22} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t" style={{ borderColor: 'rgba(74,21,75,0.1)' }}>
          <p className="text-center text-sm" style={{ color: 'rgba(74,21,75,0.35)' }}>
            © 2025 Talengers. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
